const CustomerLogosSection = () => {
    return (
        <section className="basic-area" style={{ backgroundColor: "#f8f9fa" }}>
            <div className="container">
                <h2 style={{textAlign:"center", fontSize: "32px"}}>
                    Hospitality Businesses using Katalife
                </h2>
                <div className="customer-logos-carousel">
                    <div className="customer-logos-track">
                        <a href="https://www.instagram.com/thehappynepalese/?hl=en" target="_blank" rel="noopener noreferrer">
                            <div className="customer-logo-item">
                                <img src="/images/customerlogos/the-happy-nepalese.jpeg" alt="The Happy Nepalese" />
                            </div>
                        </a>
                        <a href="https://saffronurbankitchen.com/" target="_blank" rel="noopener noreferrer">
                            <div className="customer-logo-item">

                                <img src="/images/customerlogos/saffron-urban-kitchen.jpeg" alt="Saffron Urban Kitchen" />

                            </div>
                        </a>
                        <a href="https://www.instagram.com/pizza_blessing/?hl=en" target="_blank" rel="noopener noreferrer">
                            <div className="customer-logo-item">
                                <img src="/images/customerlogos/aryatas-pizza-blessings.jpeg" alt="Aryatas Pizza Blessings" />
                            </div>
                        </a>
                        <a href="https://www.cattlecallomaha.com/" target="_blank" rel="noopener noreferrer">
                        <div className="customer-logo-item">
                            <img src="/images/customerlogos/cattle-call-omaha.jpg" alt="Cattle Call Omaha" />
                        </div>
                        </a>
                        <a href="https://www.ktmmomostation.com/" target="_blank" rel="noopener noreferrer">
                        <div className="customer-logo-item">
                            <img src="/images/customerlogos/ktm-momo-station.jpg" alt="KTM Momo Station" />
                        </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CustomerLogosSection;
